module.exports = __webpack_public_path__ + "img/samsung-galaxy-j7.cc386c48.png";